import React, { ChangeEvent } from "react";
import { UseFormHookResult } from "features/shared/forms/hooks/useForm";
import { useTranslation } from "react-i18next";
import { BoolEnum } from "features/shared/enums/boolEnum";
import FormGroup from "features/shared/forms/components/FormGroup";
import RadioBox from "features/shared/forms/components/radioBox/RadioBox";
import { RadioBoxDesignProps } from "./RadioBoxDesignProps";
import styles from "./radioBoxBoolSubForm.module.scss";

type Props = {
  formHandler: UseFormHookResult;
  name: string;
  label?: string;
  trueBox?: RadioBoxDesignProps;
  falseBox?: RadioBoxDesignProps;
  classNameFormGroup?: string;
};

const RadioBoxBoolSubForm = ({
  formHandler,
  name,
  label,
  trueBox,
  falseBox,
  classNameFormGroup,
}: Props) => {
  // translations
  const tBool = useTranslation("shared\\enums\\boolEnum").t;

  // form hook props
  const { errors, getFormValue, setFormValue, validateFormField } = {
    ...formHandler,
  };

  // helpers
  const getRadioBoxClass = (designProps: RadioBoxDesignProps | undefined) => {
    let boxClass =
      designProps && designProps.className ? ` ${designProps.className}` : "";

    return `${styles.radioBoxBool}${boxClass}`;
  };

  // handlers
  const radioBoxChangeHandler = (e: ChangeEvent<HTMLInputElement>) => {
    const name = String(e.target.name);
    const value = e.target.value;
    let boolValue: boolean | undefined;

    if (value && typeof value === "string") {
      if (value === "True") {
        boolValue = true;
      } else if (value === "False") {
        boolValue = false;
      }
    }

    setFormValue(name, boolValue);
    validateFormField(name, boolValue);
  };

  // render
  return (
    <FormGroup
      labelText={label}
      validationError={errors[name]}
      className={classNameFormGroup}
    >
      <div className="row mx-n2">
        <div className="col-6 col-sm px-2">
          <RadioBox
            label={trueBox?.text ?? tBool(BoolEnum.True)}
            icon={trueBox?.icon ?? { icon: "check-circle" }}
            name={name}
            onChange={radioBoxChangeHandler}
            checked={getFormValue(name) === true}
            value={BoolEnum.True}
            className={getRadioBoxClass(trueBox)}
            heightAsFormControl={trueBox?.heightAsFormControl ?? true}
            disabled={trueBox?.disabled}
          />
        </div>
        <div className="col-6 col-sm px-2">
          <RadioBox
            label={falseBox?.text ?? tBool(BoolEnum.False)}
            icon={falseBox?.icon ?? { icon: "times-circle" }}
            name={name}
            onChange={radioBoxChangeHandler}
            checked={getFormValue(name) === false}
            value={BoolEnum.False}
            className={getRadioBoxClass(falseBox)}
            heightAsFormControl={falseBox?.heightAsFormControl ?? true}
            disabled={falseBox?.disabled}
          />
        </div>
      </div>
    </FormGroup>
  );
};

export default RadioBoxBoolSubForm;
